import React, { useEffect } from "react";

import Service_page from "./service-page/Service_page";

const Services = () => {


  return (
    <>
      {/* Slow Smooth Fade Up */}
      <div >
        <Service_page />
      </div>

    
    </>
  );
};

export default Services;